import {
  green, grey, orange,
} from '@material-ui/core/colors';

export const STATUS_AS_CONFIG = {
  1: { label: 'Integrado com Acordo Seguro', color: green[500] },
  2: { label: 'Não integrado com Acordo Seguro', color: grey[500] },
  3: { label: 'Falha na integração com Acordo Seguro', color: orange[500] },
};

export const STATUS_AS_DEFAULT_CONFIG = {
  label: 'Sincronização com Acordo Seguro pendente',
  color: grey[500],
};

export const STATUS_AS_TOOLTIP = 'Status de integração com o Acordo Seguro';
